import { render, staticRenderFns } from "./ContentDiffStats.vue?vue&type=template&id=7037302a"
import script from "./ContentDiffStats.vue?vue&type=script&lang=js"
export * from "./ContentDiffStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports